<template>
  <el-dialog :visible.sync="commentBoxVisiable"
             :center="true"
             :destroy-on-close="true"
             :close-on-click-modal="false"
             custom-class="comment_box">
    <span slot="title"
          class="dialog-title">
      <span>
        <i style="font-size: 18px; color: #e40030; font-weight: 500"></i>
        {{ title }}
      </span>
    </span>
    <el-form ref="form"
             :model="form"
             :rules="rules">
      <el-form-item prop="comment">
        <el-input type="textarea"
                  :rows="5"
                  resize="none"
                  maxlength="500"
                  :placeholder="placeholder"
                  v-model="form.comment"
                  @blur="handleCommentBlur"
                  show-word-limit>
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 round
                 size="medium"
                 class="custom-btn"
                 @click="handleConfirm"
                 :disabled="disabled">{{ $t('btn.confirm') }}
      </el-button>

      <el-button round
                 size="medium"
                 class="custom-btn"
                 @click="handleCancel"
                 :disabled="disabled">{{ $t('btn.cancel') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Index',
  props: {
    callBack: {
      type: Function,
      default: function (event) {
        this.default.methods.close();
      }.bind(this)
    },
    title: {
      // 弹出框的 title
      type: String
    },
    placeholder: {
      // 弹出框的 title
      type: String
    }
  },
  data() {
    return {
      commentBoxVisiable: false,
      disabled: false,
      form: {
        comment: ''
      }
    };
  },
  created() { },
  methods: {
    async confirm(param) {
      this.disabled = true;
      if (this.callBack) {
        const [err, data] = await this.$awaitWrap(this.callBack(param));
      }
      this.disabled = false;
      this.close();
    },
    handleConfirm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.confirm(this.form.comment);
        }
      });
    },
    handleCancel() {
      this.close();
    },
    handleCommentBlur() {
      this.form.comment = this.form.comment.trim();
    },
    close() {
      this.commentBoxVisiable = false;
      this.disabled = false;
    }
  },
  computed: {
    rules() {
      const rules = {
        comment: [
          { required: true, message: this.placeholder, trigger: 'blur' }
        ]
      };
      return rules;
    }
  }
};
</script>

<style lang="less">
.comment_box {
  width: 800px;
  border-radius: 10px;

  /deep/ .el-dialog__header {
    height: 60px;
    font-size: 14px;
    font-weight: bolder;
    line-height: 60px;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  .dialog-footer {
    /deep/ .el-button {
      margin: 50px 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?84c4ca68